import { X, Home, ShieldCheck } from "lucide-react";

// Toont in welke huishoudens een gebruiker zit (met rol). user: { name, households: [{org_id,name,role}] }
export default function HouseholdsModal({ user, onClose, currentOrgId }) {
  if (!user) return null;
  const list = user.households || [];
  return (
    <div className="fixed inset-0 z-[120] bg-black/50 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose} data-testid="sa-households-modal">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between p-4 border-b border-slate-100">
          <div>
            <p className="font-head font-black text-lg leading-tight">{user.name}</p>
            <p className="text-xs text-slate-400">{list.length} {list.length === 1 ? "huishouden" : "huishoudens"}</p>
          </div>
          <button onClick={onClose} data-testid="sa-households-modal-close" className="p-1.5 rounded-lg hover:bg-slate-100"><X className="w-5 h-5 text-slate-500" /></button>
        </div>
        <div className="p-3 space-y-1.5 max-h-[60vh] overflow-auto">
          {list.map((h) => (
            <div key={h.org_id} className={`flex items-center gap-3 rounded-xl px-3 py-2.5 border ${h.org_id === currentOrgId ? "bg-indigo-50 border-indigo-200" : "bg-slate-50 border-slate-200"}`} data-testid={`sa-hh-modal-row-${h.org_id}`}>
              <div className="w-9 h-9 rounded-xl bg-white border border-slate-200 flex items-center justify-center shrink-0"><Home className="w-4 h-4 text-indigo-600" strokeWidth={2.5} /></div>
              <div className="min-w-0 flex-1">
                <p className="font-bold text-sm truncate">{h.name}</p>
                <p className="text-xs text-slate-400 font-mono">{h.org_id}</p>
              </div>
              <span className={`inline-flex items-center gap-1 text-xs font-bold rounded-full px-2.5 py-1 shrink-0 ${h.role === "beheerder" ? "text-indigo-700 bg-indigo-100" : "text-slate-600 bg-slate-200"}`}>
                {h.role === "beheerder" && <ShieldCheck className="w-3 h-3" />}{h.role}
              </span>
            </div>
          ))}
          {list.length === 0 && <p className="text-sm text-slate-400 px-2 py-4 text-center">Geen huishoudens.</p>}
        </div>
      </div>
    </div>
  );
}
